import React, { useEffect, useMemo, useState } from "react";
import styles from "./academic-view.module.css";
import { Col, Row, Spin, Typography } from "antd";
import SVGIcon from "../../../../../constants/SVGIcon";
import CustomButton from "../../../../../common/custom-button/custom-button";
import AddEditSubject from "../add-edit-subject/add-edit-subject";
import {
  deleteSubject,
  fetchSubjectsAcademicView,
} from "../../../../../services/subject";
import SubjectsClassesStatCard from "../../../../../components/subjects-classes-stat-card/subjects-classes-stat-card";
import EmptyLoader from "../../../../../components/emptyloader/emptyloader";

const AcademicView = () => {
  const [loading, setLoading] = useState(false);
  const [showAddSubject, setShowAddSubject] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [editSubjectData, setEditSubjectData] = useState(null);

  useEffect(() => {
    getSubjectsAcademicView();
  }, []);

  const getSubjectsAcademicView = async () => {
    try {
      setLoading(true);
      const response = await fetchSubjectsAcademicView();
      if (response.status) {
        setSubjectList(response?.data?.data?.finalResult);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const formattedLevels = (levels = []) => {
    return levels?.length ? levels.join(", ") : "-";
  };

  const handleCreateSubject = () => {
    setEditSubjectData(null);
    setShowAddSubject(!showAddSubject);
  };

  const handleEdit = (data) => {
    setEditSubjectData(data);
    setShowAddSubject(!showAddSubject);
  };

  const handleDelete = async (data) => {
    try {
      await deleteSubject(data?.id);
      getSubjectsAcademicView();
    } catch (err) {
      console.log(err);
    }
  };

  const handleCloseDrawer = () => {
    setShowAddSubject(false);
    setEditSubjectData(null);
    getSubjectsAcademicView();
  };

  const menuItems = [
    { label: "Edit Subject", onClick: handleEdit },
    { label: "Delete Subject", onClick: handleDelete },
  ];

  return (
    <>
      <div className={styles.filter_container}>
        <Typography className={styles.title}>By Subject</Typography>
        <CustomButton
          title="Create Subject"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={handleCreateSubject}
        />
      </div>

      <EmptyLoader loading={loading} isDataAvailable={subjectList?.length} />

      {subjectList?.map((item, index) => (
        <div className={styles.level_data} key={index}>
          <Typography className={styles.title}>
            {item.department?.toUpperCase()}
          </Typography>
          <Row gutter={[16, 16]}>
            {item.subjects.map((child, child_index) => (
              <Col span={6} key={child_index}>
                <SubjectsClassesStatCard
                  data={child}
                  total_male={child?.teachers_male ?? 0}
                  total_female={child?.teachers_female ?? 0}
                  total_teachers={child?.teachers_count ?? 0}
                  levels={formattedLevels(child?.forms) ?? []}
                  is_subject={true}
                  subject={child?.name ?? "-"}
                  menuItems={menuItems}
                />
              </Col>
            ))}
          </Row>
        </div>
      ))}

      {showAddSubject ? (
        <AddEditSubject
          onClose={handleCloseDrawer}
          open={showAddSubject}
          editSubjectData={editSubjectData}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AcademicView;
